import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const SalesManagerEmail = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  return (
    <TextInput
      label={
        fieldData.role === 'SALES_REP'
          ? 'Sales Manager Email *'
          : 'Manager Email*'
      }
      value={fieldData.salesManagerEmail}
      error={
        'salesManagerEmail' in formErrors
          ? formErrors.salesManagerEmail.message
          : undefined
      }
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            salesManagerEmail: { message: 'Field is required' }
          });
        else if (!/^[A-Za-z0-9._+-]+@[a-z]+\.[a-z]{2,3}$/.test(value)) {
          setFormErrors({
            ...formErrors,
            salesManagerEmail: {
              message: 'Please enter a valid email address'
            }
          });
        } else {
          const errors = { ...formErrors };
          delete errors.salesManagerEmail;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          salesManagerEmail: value
        }));
      }}
    />
  );
};

SalesManagerEmail.propTypes = {
  formErrors: PropTypes.shape({
    salesManagerEmail: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default SalesManagerEmail;
